import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react'

interface MapListContextProps {
  isListVisible: boolean
  setListState: (state: boolean) => void
  hiddenSearch: boolean
  setHiddenSearch: React.Dispatch<React.SetStateAction<boolean>>
  listWrapperRef: React.RefObject<HTMLDivElement>
}

const MapListContext = createContext<MapListContextProps | undefined>(undefined)

interface MapListProviderProps {
  children: ReactNode
  initialListVisible?: boolean
}

export const MapListProvider: React.FC<MapListProviderProps> = ({
  children,
  initialListVisible = false
}) => {
  const listWrapperRef = useRef<HTMLDivElement | null>(null)
  const [isListVisible, setIsListVisible] = useState(initialListVisible)
  const [hiddenSearch, setHiddenSearch] = useState<boolean>(true)

  useEffect(() => {
    window.dataLayer.push({
      viewType: isListVisible ? 'list' : 'map'
    })
  }, [isListVisible])

  const setListState = (state: boolean) => {
    if (listWrapperRef.current) {
      listWrapperRef.current.scrollTop = 0
    }
    setIsListVisible(state)
  }

  return (
    <MapListContext.Provider
      value={{
        isListVisible,
        setListState,
        hiddenSearch,
        setHiddenSearch,
        listWrapperRef
      }}
    >
      {children}
    </MapListContext.Provider>
  )
}

export const useMapList = (): MapListContextProps => {
  const context = useContext(MapListContext)
  if (!context) {
    throw new Error('useMapList must be used within a MapListProvider')
  }
  return context
}
